import { Injectable } from '@angular/core';
import PocketBase from 'pocketbase';

const POCKETBASE_URL = 'https://pb.scuvanya.online';
const COOKIE_DOMAIN = '.scuvanya.online';

// Central identity source shared by every *.scuvanya.online hobby project (see
// pb.scuvanya.online). This service does NOT replace Fraternity Wars' own login/user model -
// it only gives the auth guard a way to notice "the user is already logged into the central
// account" so it can silently bridge that into a normal Fraternity Wars session via
// POST /api/auth/sso (see AuthService.ssoLogin() and auth.guard.ts).
//
// The PocketBase auth state is mirrored into a `pb_auth` cookie with Domain=.scuvanya.online.
// That means: logging in on ANY *.scuvanya.online subdomain (e.g. a central hub) makes that
// session visible here too via `loadFromCookie`, and vice versa - "einmal einloggen, ueberall
// eingeloggt". Deliberately guarded behind an `*.scuvanya.online` hostname check so local dev
// (localhost) never reads/writes cookies on a domain it doesn't own.
@Injectable({ providedIn: 'root' })
export class PocketbaseService {
  readonly pb = new PocketBase(POCKETBASE_URL);

  constructor() {
    const isScuvanyaHost = typeof location !== 'undefined' && location.hostname.endsWith('scuvanya.online');

    if (isScuvanyaHost) {
      this.pb.authStore.loadFromCookie(document.cookie);
    }

    this.pb.authStore.onChange(() => {
      if (!isScuvanyaHost) return;
      document.cookie = this.pb.authStore.exportToCookie({
        httpOnly: false,
        secure: true,
        sameSite: 'Lax',
        domain: COOKIE_DOMAIN,
        path: '/',
      });
    }, true);
  }
}
